<template>
	<b-form data-vv-scope="identity" @submit.prevent="nextStep">
		<div class="d-flex flex-column" style="gap: 24px;">
			<div class="title">
				<h5>{{ $t("views.seller.my_account.text_1282") }}</h5>
				<p>{{ $t("views.seller.my_account.text_1283") }}</p>
			</div>
      <b-row>
        <b-col cols="12" md="12">
          <BaseInputFile 
            v-model="files.identity"
            :extensions="['pdf', 'jpg', 'png']"
            :maxSize="10"
            :instructionsLabel="$t('views.seller.my_account.text_1284')"
            :instructions="[
              { icon: 'gallery.png', label: this.$t('views.seller.my_account.text_1285')},
              { icon: 'card-tick.png', label: this.$t('views.seller.my_account.text_1286')},
              { icon: 'wallet.png', label: this.$t('views.seller.my_account.text_1287')},
              { icon: 'camera-slash.png', label: this.$t('views.seller.my_account.text_1288')},
            ]"
            :errorMessage="filesErrors.identity"
            sizeUnit="mb"
          />
        </b-col>
      </b-row>
		</div>

		<div class="divider"></div>
		
		<div class="d-flex flex-column" style="gap: 24px;">
			<div class="title">
				<h5>{{ $t("views.seller.my_account.text_1289") }}</h5>
				<p>{{ $t("views.seller.my_account.text_1290") }}</p>
			</div>
      <b-row>
        <b-col cols="12" md="12">
          <BaseInputFile 
            v-model="files.selfie"
            :extensions="['pdf', 'jpg', 'png']"
            :maxSize="10"
            :instructionsLabel="$t('views.seller.my_account.text_1291')"
            :instructions="[
              { icon: 'sun.png', label: this.$t('views.seller.my_account.text_1292')},
              { icon: 'headphones.png', label: this.$t('views.seller.my_account.text_1293')},
              { icon: 'user-tick.png', label: this.$t('views.seller.my_account.text_1294')},
              { icon: 'gallery-tick.png', label: this.$t('views.seller.my_account.text_1295')},
            ]"
            :errorMessage="filesErrors.selfie"
            sizeUnit="mb"
          />
        </b-col>
      </b-row>
		</div>
	</b-form>
</template>

<script>
import ValidationService from "@/services/resources/ValidationService";

const identityValidationService = ValidationService.build();

import readFile from '@/utils/readFile';

export default {
	name: 'IdentityVerificationFormStep',
	props: {
    user: {
      type: Object,
      required: true
    }
	},
	data() {
		return {
      files: {
        identity: null,
        selfie: null,
      },
      filesErrors: {
        identity: '',
        selfie: '',
      },
      identityValidation: {
        id: null
      }
    }
	},
  watch: {
    files: {
      handler(newValue) {
        for (const key in newValue) {
          if (newValue[key]) {
            this.filesErrors[key] = '';
          }
        }
      },
      deep: true,
    },
  },
	methods: {
    async validateForm() {
      try {
        return this.validateFiles();
      } catch(error) {
        return false;
      }
    },
    
    async handleSubmit() {
      try {
        const data = {
          id: this.identityValidation.id
        };

        if (this.files.identity.size) {
          data.doc_front = await readFile(this.files.identity);
        }

        if (this.files.selfie.size) {
          data.doc_back = await readFile(this.files.selfie);
        }

        this.$root.$emit('on-saving', true);

        if (!this.identityValidation.id) {
          const { id } = await identityValidationService.create();
          this.identityValidation.id = id;
        }

        await identityValidationService.create(data, '/upload');

        this.$bvToast.toast(
          this.$t("views.seller.my_account.text_1197"),
          {
            title: this.$t("views.seller.my_account.text_1263"),
            variant: "success",
            autoHideDelay: 5000,
            appendToast: true,
          }
        );
      } catch (error) {
        console.error('IdentityVerificationFormStep::handleSubmit', error);
      } finally {
        this.$root.$emit('on-saving', false);
      }
    },
    validateFiles() {
      let isValid = true;

      for (const key in this.files) {
        if (this.files[key] === null) {
          isValid = false;
          this.filesErrors = {
            ...this.filesErrors,
            [key]: this.$t('views.seller.my_account.text_1338')
          }
        }
      }
      return isValid;
    },
    fillDocuments({ doc_front, doc_back, id }) {
      if (!doc_front || !doc_back) {
        return;
      }

      this.identityValidation.id = id;

      if (doc_front) {
        this.files.identity  = this.fakeFile(doc_front, 'identidade');
      }

      if (doc_back) {
        this.files.selfie = this.fakeFile(doc_back, 'selfie');
      }
    },
    fakeFile(path, fileName) {
      const ext = path.split('.').pop().toLowerCase();
      const blob = new Blob();
      return new File([blob], `${fileName}.${ext}`);
    }
	},
  mounted() {
    if (this.$root.myAccountData && this.$root.myAccountData.identityValidation) {
      this.identityValidation = this.$root.myAccountData.identityValidation;

      if (this.identityValidation.doc_front_status || this.identityValidation.doc_back_status ) {
        this.fillDocuments(this.identityValidation);
      }
    }
  }
};
</script>
